// DESIGN_SYSTEM_NOTES: wfm-empty / wfm-small / wfm-tiny and --wfm-* tokens.
//
// The empty slot for any content section — 33 pages already use `wfm-empty`.
// Extracted from pages/workforce/wfShared.jsx (which now re-exports it).
//
//   <EmptyState icon={Inbox} title="Nessuna pratica" hint="Modifica i filtri." />

import React from 'react';

export default function EmptyState({ icon: Icon, title, hint }) {
  return (
    <div className="wfm-empty">
      {Icon && <Icon size={48} className="mx-auto mb-3" style={{ color: 'var(--wfm-text-muted)' }} />}
      <p className="wfm-small font-medium">{title}</p>
      {hint && <p className="wfm-tiny mt-1">{hint}</p>}
    </div>
  );
}
